export default __webpack_public_path__ + "static/media/three-dots.1da57468.svg";